$(function(){
    jQuery.extend( jQuery.fn.dataTableExt.oSort, {
        "date-eu-pre": function ( date ) {
            date = date.replace(" ", "");
            if ( ! date ) { return 0; }
            var year = "", eu_date = date.split(/[\.\-\/]/);

            /*year (optional)*/
            if ( eu_date[2] ) { year = eu_date[2]; }

            else { year = 0; }

            /*month*/
            var month = eu_date[1];
            if ( month.length == 1 ) { month = 0 + month; }

            /*day*/
            var day = eu_date[0];
            if ( day.length == 1 ) { day = 0 + day; }
            return (year + month + day) * 1;
        },

        "date-eu-asc": function ( a, b ) {
            return ((a < b) ? -1 : ((a > b) ? 1 : 0));
        },

        "date-eu-desc": function ( a, b ) {
            return ((a < b) ? 1 : ((a > b) ? -1 : 0));
        }
    } );

  var language_option = {
    "lengthMenu": "Mostra _MENU_  elementi per pagina",
    "zeroRecords": "Nessun risultato trovato",
	"info": "Elementi totali _TOTAL_",
    "infoEmpty": "",
    "infoFiltered": "",
    "search": "Cerca: ",
    "oPaginate": {
		"sFirst": "Inizio",
		"sPrevious": "Precedente",
		"sNext": "Successivo",
		"sLast": "Fine"
		}
  };

  // Bootstrap-style DOM layout: produce gli stessi <div class="row"> del plugin
  // dataTables.bootstrap.js usato in produzione, senza doverlo importare.
  var bootstrapDom =
    "<'row'<'col-sm-6'l><'col-sm-6'f>>" +
    "<'row'<'col-sm-12'tr>>" +
    "<'row'<'col-sm-5'i><'col-sm-7'p>>";

  // Renderer paginazione Bootstrap: genera <ul class="pagination"><li><a>
  // invece dei <a class="paginate_button"> piatti del core DataTables.
  // Replica il comportamento di dataTables.bootstrap.js usato in produzione.
  $.fn.dataTable.ext.renderer.pageButton.bootstrap = function (settings, host, idx, buttons, page, pages) {
    var api = new $.fn.dataTable.Api(settings);
    var lang = settings.oLanguage.oPaginate;
    var btnDisplay, btnClass;

    var attach = function (container, buttons) {
      var i, ien, node, button;
      var clickHandler = function (e) {
        e.preventDefault();
        if (!$(e.currentTarget).hasClass('disabled')) {
          api.page(e.data.action).draw('page');
        }
      };

      for (i = 0, ien = buttons.length; i < ien; i++) {
        button = buttons[i];

        if ($.isArray(button)) {
          attach(container, button);
        } else {
          btnDisplay = '';
          btnClass = '';

          switch (button) {
            case 'ellipsis':
              btnDisplay = '&hellip;';
              btnClass = 'disabled';
              break;
            case 'first':
              btnDisplay = lang.sFirst;
              if (page === 0) { btnClass = 'disabled'; }
              break;
            case 'previous':
              btnDisplay = lang.sPrevious;
              if (page === 0) { btnClass = 'disabled'; }
              break;
            case 'next':
              btnDisplay = lang.sNext;
              if (page >= pages - 1) { btnClass = 'disabled'; }
              break;
            case 'last':
              btnDisplay = lang.sLast;
              if (page >= pages - 1) { btnClass = 'disabled'; }
              break;
            default:
              btnDisplay = button + 1;
              btnClass = page === button ? 'active' : '';
              break;
          }

          if (btnDisplay) {
            node = $('<li>', {
              'class': btnClass,
              'id': idx === 0 && typeof button === 'string'
                ? settings.sTableId + '_' + button
                : null
            })
            .append($('<a>', { 'href': '#', 'tabindex': settings.iTabIndex }).html(btnDisplay))
            .appendTo(container);

            settings.oApi._fnBindAction(node, { action: button }, clickHandler);
          }
        }
      }
    };

    var activeEl;
    try { activeEl = $(host).find(document.activeElement).data('dt-idx'); } catch (e) {}

    $(host).empty();
    var container = $('<ul/>').addClass('pagination').appendTo(host);
    attach(container, buttons);

    if (activeEl !== undefined) {
      $(host).find('[data-dt-idx=' + activeEl + ']').focus();
    }
  };

  // Imposta il renderer Bootstrap come default per tutti i DataTable
  $.extend($.fn.dataTable.defaults, {
    renderer: 'bootstrap'
  });

  if($('#languagess_table').length > 0){
    $('#languagess_table').DataTable({
        dom: bootstrapDom,
        lengthMenu: [[100, 200, 500, -1], [100, 200, 500, 'Mostra Tutti']],
        columnDefs: [
            { type: 'date-eu', sortable: true, targets: [0] },
            { sortable: false, targets: [ 1,2, 3, 4, 5, 6] },
        ],
        columns: [
            { "width": "110" },
            { "width": "200" },
            { "width": "200" },
            { "width": "200" },
            { "width": "200" },
            { "width": "200" },
            { "width": "100" }
        ],
        fixedColumns: true,
        "order": [ 0, 'desc' ],
        "language": language_option
    });
  }

  if($('#routes_table').length > 0){
    $('#routes_table').DataTable({
      dom: bootstrapDom,
	  lengthMenu: [[100, 200, 500, -1], [100, 200, 500, 'Mostra Tutti']],
      columnDefs: [
        { type: 'date-eu', sortable: true, targets: [0] },
        { sortable: false, targets: [ 2, 3, 4, 5, 6, 7 ] }
      ],
      columns: [
        { "width": "110" },
        { "width": "260" }
      ],
      fixedColumns: true,
      "order": [ 0, 'desc' ],
      "language": language_option
    });
  }

  if($('#unique_rfg_table').length > 0){
    $('#unique_rfg_table').DataTable({
        dom: bootstrapDom,
        lengthMenu: [[100, 200, 500, -1], [100, 200, 500, 'Mostra Tutti']],
        columnDefs: [
            { type: 'date-eu', sortable: true, targets: [1, 2] },
            { sortable: false, targets: [0, 3, 4, 5, 6] }
        ],
        columns: [
            { "width": "260" },
            { "width": "160" }
        ],
        fixedColumns: true,
        "order": [ 1, 'desc' ],
        "language": language_option
    });
  }

  if($('#paths_table').length > 0){
    $('#paths_table').DataTable({
        dom: bootstrapDom,
        lengthMenu: [[100, 200, 500, -1], [100, 200, 500, 'Mostra Tutti']],
        columnDefs: [
            { type: 'date-eu', sortable: true, targets: [0] },
            { sortable: false, targets: [2, 3, 4, 5, 6] },
        ],
        columns: [
            { "width": "110" },
            { "width": "260" }
        ],
        fixedColumns: true,
        "order": [ 0, 'desc' ],
        "language": language_option
    });
  }

  if($('#companies_table').length > 0){
    $('#companies_table').DataTable({
        dom: bootstrapDom,
        "lengthMenu": [[100, 200, 500, -1], [100, 200, 500, 'Mostra Tutti']],
        "order": [[ 0, "asc" ]],
        "columnDefs": [
            { "sortable": false, "targets": [ 3 ] }
        ],
        "language": language_option
    });
  }


  if($('#users_table').length > 0){
    $('#users_table').DataTable({
      dom: bootstrapDom,
	  "lengthMenu": [[100, 200, 500, -1], [100, 200, 500, 'Mostra Tutti']],
      "order": [[ 1, "asc" ]],
      "columnDefs": [
        { "sortable": false, "targets": [ 3, 4 ] }
      ],
        "language": language_option
    });
  }

  if($('#tags_table').length > 0){
    $('#tags_table').DataTable({
      dom: bootstrapDom,
      "lengthMenu": [[100, 200, 500, -1], [100, 200, 500, 'Mostra Tutti']],
      "order": [[ 1, "asc" ]],
      "columnDefs": [
        { "sortable": false, "targets": [ 0, 2, 3, 4, 5, 6, 7, 8] }
      ],
      "language": language_option
    });
  }

  if($('#tags_table_index').length > 0){
    $('#tags_table_index').DataTable({
      dom: bootstrapDom,
	  "lengthMenu": [[100, 200, 500, -1], [100, 200, 500, 'Mostra Tutti']],
      "aoColumnDefs": [
        { "bSortable": false, "aTargets": [ 2, 9] }
      ],
        "language": language_option
    });
  }

  if($('#messages_table').length > 0){
    $('#messages_table').DataTable({
      dom: bootstrapDom,
      "aoColumnDefs": [
        { "bSortable": false, "aTargets": [ 1, 2, 3, 4, 5 ] }
      ],
        "language": language_option
    });
  }

    if($('#operator_working_maps').length > 0){
        $('#operator_working_maps').DataTable({
            dom: bootstrapDom,
            "language": language_option
        });
    }

    if($('#search_table').length > 0){
        $('#search_table').DataTable({
            dom: bootstrapDom,
            "language": language_option
        });
    }
});